export const GET_USER_DATA = /* GraphQL */ `
  query ClientQuery {
    user {
      address
      city
      country
      createdAt
      zipCode
      streetNumber
      streetName
      notification
      email
      firstName
      id
      brand
      lastName
      name
      state
      photo
      phone
      updatedAt
       manufacturerObject {
        brand
        isBusinessInfo
        isStripeConnected
        isShopifyConnected
        stripeConnectUrl
        isTreeMaker
        businessForm
      }
      banner {
        image
        video
        btnLabel
        btnUrl
        title
        description
      }
      type
    }
  }
`;
